import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GUITAR_LESSONS } from './guitar-lessons.data';
import { GuitarLesson } from '../../models/guitar-lesson.model';

@Component({
  selector: 'app-guitar-lesson-detail',
  templateUrl: './lesson-detail.component.html',
  styleUrls: ['./lesson-detail.component.scss'],
  standalone: false,
})
export class LessonDetailComponent implements OnInit {
  lesson?: GuitarLesson;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.lesson = GUITAR_LESSONS.find(l => l.id === id);
    });
  }
}
